<template>
  <!-- table组件 -->
  <div class="h-table-view">
    <el-table class="h-table" height="100%" :data="tableData" stripe :ref="thisRef" :cell-style="cellStyle" :header-cell-style="headerCellStyle" :row-style="rowStyle" @selection-change="handleSelectionChange" @cell-click="cellClick">
      <template v-for="(item, index) in config.columns">
        <el-table-column :type="item.type" :width="55" align="left" v-if="item.type == 'selection'" :key="index"></el-table-column>
        <el-table-column :prop="item.prop" :label="item.label" :width="item.width ? item.width : ''" :align="item.align ? item.align : 'center'" v-if="!item.type&&!item.formatter" :key="index" show-overflow-tooltip></el-table-column>
        <el-table-column :prop="item.prop" :label="item.label" :width="item.width ? item.width : ''" :align="item.align ? item.align : 'center'" v-if="!item.type&&item.formatter" :key="index" show-overflow-tooltip :formatter='formatter'></el-table-column>
        <el-table-column :label="item.label ? item.label : '操作'" :width="item.width ? item.width : ''" align="center" v-if="item.type == 'slot'" :key="index" :fixed="item.fixed?item.fixed:false">
          <template slot-scope="scope">
            <template v-for="(item2, index2) in item.slot">
              <el-button type="text" size="mini" :icon="item2.icon ? item2.icon : 'el-icon-edit'" :style="item2.color ? 'color:' + item2.color : 'color:#3B5EFF'" @click="handleSolt(index2, scope.row)" v-if="!item2.api" :key="index2">
                {{ item2.label }}
              </el-button>
              <el-button type="text" size="mini" icon="el-icon-delete" style="color:#F37978" @click="handleDel(item2.api, scope.row, item2.idkey)" v-if="item2.api" :key="index2">
                删除
              </el-button>
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div class="pagination">
      <el-pagination background @current-change="currentChange" @size-change="sizeChange" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" :total="total"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      thisRef: this._uid + '_tableRef',
      //表头参数
      columns: [],
      //table数据
      tableData: [],
      //table数据总数
      total: 0,
      //当前页index
      pageIndex: 1,
      //每页显示数据量
      pageSize: 10,
      //table表头样式
      headerCellStyle: {
        color: '#0A0F1B'
      },
      //table单元格样式
      cellStyle: { padding: '10px 0' },
      // 行样式
      rowStyle: {
        color: '#959CAE'
      },
      //筛选数据
      searchData: {},
      //是否正在获取table
      doGet: false,
      multipleSelection: []
    }
  },
  props: {

    /**
     * 配置项
     * api:查询tableData接口,传入api时默认
     * searchData:查询数据是的筛选数据
     * columns:表头设置
     *         label:表头显示名称 
     *         prop：对应data中的key
     *         type:slot  设置插槽，插入按钮 
     *              icon 对应的图标，不传即无图标
     *              label 按钮显示名称
     *              color 按钮颜色
     *              api 如果传入api即认为是删除按钮
     *              key 删除按钮默认根据id删除，传入key即为根据key删除
     *              按钮的触发由handleSolt接受回调
     * data:显示数据
     * 示例：
     *      > confing:{
     *      >    api: 'getTable',
     *      >    searchData:{keywords:'abc'},
     *      >    columns: [
     *      >    { label: '编号', prop: 'number' },
     *      >    { label: '名称', prop: 'name' },
     *      >    { type: 'slot', width: '200', slot: [{ icon: 'el-icon-edit', label: '编辑',color:'#000000' }, { icon: 'el-icon-view', label: '查看' },{api:'delRow',key:'orgId' }
     *      >    ],
     *      >    data: [],
     *      >    
     *      > }
     */
    config: {
      type: Object,
      default: function () {
        return {}
      }
    },
    // 触发多选
    multipleSelectionChange: {
      type: Object
    },
    // table插槽按钮触发回调
    handleSolt: {
      type: Function,
      default: function () { }
    },
    // 点击单元格回调
    handleCellClick: {
      type: Object
    },
    isBatchDelete: {
      type: Boolean | String,
      default: false
    },
    formatter: {
      type: Function,
      default: function () {

      }
    }
  },
  mounted () {
    // this.init()
    this.getData(1, 10, true)
  },
  watch: {
    // 'config.data': function (val) {
    //   console.log('监听config.data', val);
    // }
  },
  methods: {
    //初始化
    init () {
      console.log('this.config>>>>>>>>>>>>>>', this.config);
      let that = this
      // console.log(this.thisRef, '初始化tableConfig', this.config)
      if (this.config) {
        this.columns = this.config.columns
        if (this.columns.headerCellStyle) {
          this.headerCellStyle = this.columns.headerCellStyle
        }
        if (this.columns.cellStyle) {
          this.cellStyle = this.columns.cellStyle
        }
        this.columns.forEach(function (item, index) {
          if (item.slot) {
            that.cellStyle = { padding: '10px 0' }
          }
        })
        if (this.config.data) {
          this.tableData = this.config.data
        }
      } else {
        console.error('h-table初始化失败，没有获取到config')
      }
    },
    //获取table数据
    getData (pageIndex, pageSize, refreshTotalRowsNumber, defCondition) {
      let that = this
      if (!this.config.api) {
        return
      }
      if (this.doGet) {
        return
      }
      this.doGet = true
      setTimeout(function () {
        if (that.doGet) {
          that.doGet = false
        }
      }, 2000)
      let data = {}
      data = Object.assign(this.searchData, defCondition)

      data.size = pageSize
      data.current = pageIndex
      this.$API[this.config.api](data).then(res => {
        that.doGet = false
        that.total = parseInt(res.total)
        that.tableData = res.records
        this.multipleSelectionInit(res.pages)
      })
    },
    multipleSelectionInit (pages) {
      if (this.multipleSelection) {
        this.multipleSelection = []
        for (let i = 0; i < pages; i++) {
          this.multipleSelection.push([])
        }
      }
    },
    //刷新table
    update () {
      this.getData(this.pageIndex, this.pageSize, true)
    },
    // 分页导航
    currentChange (val) {
      this.pageIndex = val
      this.update()
    },
    //改变单页显示数量
    sizeChange (val) {
      this.pageSize = val
      this.update()
    },
    //多选触发改变
    handleSelectionChange (val) {
      this.multipleSelectionChange(val, this.pageIndex)
    },
    //触发筛选
    doSearch (data) {
      this.searchData = data
      this.pageIndex = 1
      this.pageSize = 10
      this.update()
    },
    //row触发删除
    handleDel (_api, row, idkey) {
      this.$confirm('删除后无法恢复,确定删除吗？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
        // center:true
      })
        .then(() => {
          let that = this
          let data = {}
          if (this.isBatchDelete === true || this.isBatchDelete === 'true' || this.isBatchDelete === '') {
            data.idList = []
            if (idkey == undefined) {
              data.idList.push(row.id)
            } else {
              data.idList.push(row[idkey])
            }
          } else {
            if (idkey == undefined) {
              data.id = row.id
            } else {
              data.id = row[idkey]
            }
          }
          this.$API[_api](data).then(
            res => {
              this.$message({
                message: '删除成功',
                duration: 2000,
                type: 'success'
              })
              this.update()
            },
            err => { }
          )
        })
        .catch(() => {
          // console.log('点击了取消');
        })
    },
    //单元格点击
    cellClick (row, column, cell, event) {
      if (this.handleCellClick) {
        this.handleCellClick(row, column)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.h-table-view
  height 100%
  display flex
  flex-direction column
  justify-content space-between
  .h-table
    flex 1
.el-pager li
  border-radius 10px !important
</style>



// WEBPACK FOOTER //
// src/components/parts/hTable.vue